export default {
  install (Vue, options) {
    let lineBreaker = text => {
      return text.replace(/\\r\\n/g, '<br />')
    }

    Vue.prototype.$lineBreaker = lineBreaker
  }
}
